import requestInstance from '../../utils/instance-utils';

export const getAppConfigs = () => requestInstance.get('app-configs');

export const getAppRuntimeConfigs = () =>
    requestInstance.get('app-runtime-configs');
